import { lazy } from '@/service/lazy'

export default [{
  name: 'TokenUsuario',
  path: '*',
  component: lazy('app/auth/login/index')
}]



// WEBPACK FOOTER //
// ./src/router/modules/auth/token.js